import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element in index.html.");

// Runtime config (and Amplify) load before React mounts, so a build shipped
// without its pool ids renders a message instead of a white page.
void import("./lib/auth/amplify-setup")
  .then(({ ensureAmplify }) => ensureAmplify())
  .then(() => {
    createRoot(root).render(
      <StrictMode>
        <App />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    root.textContent = "";
    const panel = document.createElement("main");
    panel.style.cssText =
      "font:14px/1.6 system-ui;max-width:34rem;margin:12vh auto;padding:0 1.5rem;color:#111827";
    const title = document.createElement("h1");
    title.textContent = "This build is not configured";
    const body = document.createElement("p");
    body.textContent =
      error instanceof Error ? error.message : "Unknown startup failure.";
    panel.append(title, body);
    root.append(panel);
  });
